import { css } from "vite-css-in-js"
import { defineComponent, inferProps, type ReactiveComponent } from "vue-utils"

interface Props {
	htmlContent: string
}

const whiteListedTags = new Set<string>([
	"h1",
	"h2",
	"h3",
	"h4",
	"h5",
	"h6",
	"p",
	"span",
	"strong",
	"i",
	"u",
	"s",
	"sup",
	"ul",
	"ol",
	"li",
	"table",
	"thead",
	"tbody",
	"tfoot",
	"tr",
	"th",
	"td",
	"hr",
	"div",
	"a",
	"figure",
	"mark",
	"blockquote",
	"br",
])
const whitelistedAttributes = new Set<string>(["class", "style", "href", "target"])

function sanitiseNode(element: Node): Node | null {
	if (element.nodeType === Node.TEXT_NODE) {
		return element.cloneNode(true)
	}
	if (element instanceof Element && whiteListedTags.has(element.tagName.toLowerCase())) {
		const duplicated = document.createElement(element.tagName)
		for (const attributeName of element.getAttributeNames()) {
			if (whitelistedAttributes.has(attributeName)) {
				duplicated.setAttribute(attributeName, element.getAttribute(attributeName)!)
			}
		}

		for (const child of element.childNodes) {
			const clonedChild = sanitiseNode(child)
			if (clonedChild) {
				duplicated.append(clonedChild)
			}
		}
		return duplicated
	}
	if (element instanceof Element) {
		console.log(element.tagName.toLowerCase())
	}
	return null
}
function sanitiseHtml(html: string) {
	const el = document.createElement("div")
	el.innerHTML = html
	const result = sanitiseNode(el) as HTMLDivElement
	return result.innerHTML
}

const styles = css`
	background-color: white;
	border: 1px solid rgba(0, 0, 0, 0.25);
	border-radius: 0.25rem;
	padding: 0.5rem;

	p,
	blockquote {
		margin: initial;
	}
`

const CKDisplay: ReactiveComponent<Props> = (props) => {
	return () => <div class={[styles, "ck-content"]} innerHTML={sanitiseHtml(props.htmlContent)} />
}

export default defineComponent(CKDisplay, inferProps<Props>())
